'use client';

import dynamic from 'next/dynamic';

// Dynamically import ApiErrorHandler component with no SSR
const ApiErrorHandler = dynamic(() => import('./ApiErrorHandler'), { ssr: false });

export default function ErrorHandlerWrapper() {
  return <ApiErrorHandler />;
} 